import startCase from 'lodash/startCase';

export default label => {
    const value = label.value || label;

    return label.text || startCase(value);
};
